const testAppid = "wx591b989558e74650";
//应用ID
const testAgentid = "1000097";

const prodAppid = "wx591b989558e74650";
//应用ID
const prodAgentid = "1000099";

const isDevelopment =
  process.env.NODE_ENV === "development" ||
  process.env.REACT_APP_ADRESS_ENV === "development";

export const appid = isDevelopment ? testAppid : prodAppid;
export const agentid = isDevelopment ? testAgentid : prodAgentid;
